import { Plus } from "lucide-react";
import { cn } from "@/lib/utils";

interface Props {
  onClick: () => void;
}

export function MobileFAB({ onClick }: Props) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "fixed z-50 md:hidden",
        "bottom-[4.5rem] right-4",
        "h-14 w-14 rounded-full",
        "bg-primary text-primary-foreground",
        "flex items-center justify-center",
        "shadow-lg shadow-primary/30",
        "active:scale-95 transition-transform",
        "glow-cyan-strong"
      )}
      aria-label="Procesar Documento"
    >
      <Plus className="h-6 w-6" strokeWidth={2.5} />
    </button>
  );
}
